/**
 * @copyright 2023 Nuance Communications Inc.
 * All Rights Reserved.
 */
export const LIB_VERSION = "1.0.175";